import { rSize } from 'components/utils';

export const FIRST_CELL_WIDTH = rSize(260);
